export default "__VITE_ASSET__3d4ee211__"